import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"

export const BannerBenefitsWrapper = styled.section`
  height: auto;
  width: 100%;
  padding-top: 80px;

  @media screen and (max-width: 768px) {
    padding-top: 0;
  }
`

export const BannerBenefitsContent = styled.div`
    height: auto;

    ${media.lessThan("xl")`
       padding-top: 0px;
    `} 

    ${media.lessThan("lg")`
        padding-top: 30px;
        text-align: center;
    `} 

    ${media.lessThan("md")`
        padding-top: 25px;
    `} 
`

export const BannerBenefitsCaption = styled.div`
  color: var(--dark);
  margin-bottom: 55px;

  ${media.lessThan("lg")`
        padding-top: 35px;
    `}
`

export const BannerBenefitsSubTitle = styled.h2`
  font-size: 22px;
  font-weight: 300;
  opacity: 0.6;
  line-height: 0.8;
  margin-bottom: 7px;
  letter-spacing: 1.5px;

  ${media.lessThan("lg")`
        font-size: 19px;
    `}
`

export const BannerBenefitsTitle = styled.h1`
  font-size: 60px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 30px;
  letter-spacing: -3px;

  span {
    color: var(--primary);
  }

  ${media.lessThan("lg")`
        font-size: 50px;
        margin-bottom: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 40px;
    `}
`

export const BannerBenefitsDesc = styled.p`
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 1px;
  max-width: 460px;

  ${media.lessThan("lg")`
       max-width: 600px;
       text-align: center;
       margin: 0 auto;
    `}

  ${media.lessThan("md")`
       font-size: 16px;
    `}
`

export const BannerBenefitsHero = styled(Img)`
    margin: 0 auto 0 -10px;
    margin-top: -80px;
    width: 84%;
    animation: float 3s infinite;
    z-index: 4;

    ${media.lessThan("xl")`
        margin-top: -30px;
        width: 90%;
    `} 

    ${media.lessThan("lg")`
        margin: 0 auto 40px auto;
        width: 60%;
    `} 

    ${media.lessThan("md")`
        width: 60%;
    `} 

    ${media.lessThan("sm")`
       margin-top: 20px;
       width: 74%;
    `} 
`

export const BannerBenefitsItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 2px solid var(--dark);
  border-radius: 50%;
  margin-bottom: 20px;
  transition: all 0.3s ease;

  ${media.lessThan("lg")`
        height: 80px;
        width: 80px;
        `}

  svg {
    color: var(--dark);
    width: 45px;
    transition: color 0.3s ease;

    ${media.lessThan("lg")`
       width: 35px;
    `}
  }
`

export const BannerBenefitsItemTitle = styled.h2`
  font-weight: 600;

  ${media.lessThan("lg")`
        font-size: 22px;
        max-width: 80%;
        margin: 0 auto;
    `}
`

export const BannerBenefitsItemDesc = styled.p``

export const BannerBenefitsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  text-align: left;
  color: var(--dark);
  margin-bottom: 10px;

  ${media.lessThan("lg")`
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 20px;
  `}

  &:hover ${BannerBenefitsItemIcon}{
    background-color: var(--dark);
    transform: scale(1.06);

    svg {
      color: var(--white);
    }
  }
`
